import React from 'react';
import PropTypes from 'prop-types';

import { groupBy } from 'lodash';

import CreateButton from './create_button';
import CreateModal from './create_modal';
import EmptyState from 'shared/empty_state';
import LoadingSpinner from 'components/ui/loading_spinner';
import { VouchersTable } from 'bundles/backoffice/vouchers/index/table';
import { get } from 'helpers/api';

export class VouchersTab extends React.Component {
  static propTypes = {
    proposal: PropTypes.bool,
    showForAssignment: PropTypes.bool,
    vouchersSearchPath: PropTypes.string.isRequired,
  }

  state = {}

  componentDidMount() {
    get(this.props.vouchersSearchPath)
      .then((data) => {
        this.setState({
          vouchers: data.vouchers,
        });
      });
  }

  totals = (vouchers) => {
    return {
      grossCommissionAmount: vouchers.reduce((sum, { grossCommissionAmount }) => sum + grossCommissionAmount, 0),
      transactionValue: vouchers.reduce((sum, { transactionValue }) => sum + transactionValue, 0),
    };
  }

  handleNewVoucher = (voucher) => {
    this.setState((state) => {
      return {
        vouchers: [
          ...state.vouchers,
          voucher
        ]
      };
    });
  }

  handleCreateButtonClick = (listings) => {
    this.setState({ listings });
  };

  render() {
    const { listings, pendingRequest } = this.state;

    return (
      <div className="d-flex flex-column gap-3">
        <div className="d-flex justify-content-between align-items-center gap-2">
          <h5>Vouchers</h5>
          <CreateButton
            disabled={pendingRequest}
            proposal={this.props.proposal}
            showForAssignment={this.props.showForAssignment}
            onClick={this.handleCreateButtonClick}
          />
          <CreateModal
            listings={listings}
            show={listings != null}
            onCancel={() => this.setState({ listings: null })}
            onNewVoucher={this.handleNewVoucher}
          />
        </div>
        {this.renderContent()}
      </div>
    );
  }

  renderContent() {
    if (!this.state.vouchers) {
      return <LoadingSpinner />;
    }

    if (this.state.vouchers.length === 0) {
      return <EmptyState bodyText="No vouchers have been created for this property" />;
    }

    const groupedVouchers = groupBy(this.state.vouchers, 'listing.typeLabel');

    const typeLabels = Object.keys(groupedVouchers)
      .sort()
      .reverse();

    return typeLabels.map((label) => {
      const vouchers = groupedVouchers[label];

      return (
        <React.Fragment key={label}>
          <h6>{label} Vouchers</h6>
          <div className="table-container">
            <table className="table">
              <VouchersTable
                minimal
                totals={this.totals(vouchers)}
                vouchers={vouchers}
              />
            </table>
          </div>
        </React.Fragment>
      );
    });
  }
}

export default VouchersTab;
